import {
    HttpResponse,
    CycleTimeModel,
    QueryModel,
    RequestParams,
    CycleTimeModelIEnumerableApiResultSuccess,
    CycleTimeModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class CycleTimesDataService implements CrudService<CycleTimeModel, CycleTimeModel> {
    getAll(query: CrudDataQuery<CycleTimeModel>): Promise<CrudEnumerableResponse<CycleTimeModel>> {
        return ApiService.api.getCycleTimeBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<CycleTimeModel>): Promise<CrudEnumerableResponse<CycleTimeModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<CycleTimeModel>> {
        return ApiService.api.getCycleTimeById(id, params);
    }

    create(item: CycleTimeModel, params?: RequestParams): Promise<CrudResponse<CycleTimeModel>> {
        return ApiService.api.insertCycleTime(item, params);
    }

    update(item: CycleTimeModel, params?: RequestParams): Promise<CycleTimeModel> {
        return ApiService.api.updateCycleTime(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<CycleTimeModel> {
        return ApiService.api.patchCycleTime(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<CycleTimeModel>): Promise<CrudEnumerableResponse<CycleTimeModel>> {
        return ApiService.api.deleteCycleTimes(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationCycleTime(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<CycleTimeModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: CycleTimeModel, params?: RequestParams): Promise<CrudResponse<CycleTimeModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getCycleTimeGroupped(query, params);
    }

}
